// Configure regeneratorRuntime first, so we don't error out
import './runtimeConfig'

// polyfills
import 'babel-polyfill'
import 'core-js/features/promise'

import React from 'react'
import ReactDOM from 'react-dom'

import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { unregister } from './registerServiceWorker'

import App from './components/App'

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn:
      'https://3864dd63adb84e56b929e71dbbd613da@o194799.ingest.sentry.io/5660334',
    integrations: [new Integrations.BrowserTracing()],
    environment: process.env.NODE_ENV,
  })
}

ReactDOM.render(<App />, document.getElementById('root'))

unregister()
